import React, { useContext } from "react";
import { useHistory } from 'react-router-dom'
import { SessionContextStore } from '../../context/SessionContext'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export const LogoutPopup = ({isOpen,setOpen}) => {
    const sessionContext = useContext(SessionContextStore)
    const history = useHistory()


    const handleDisagree = () => {
        setOpen(false);
    };

    const handleAgree = async () => { 
        await sessionContext.logout()
        history.push('/login')
        setOpen(false);
    }

    return <React.Fragment>
         <Dialog
            open={isOpen}
            onClose={handleDisagree}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">Logging Out</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to logout?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleDisagree} color="primary">
                Cancel and return
            </Button>
            <Button onClick={handleAgree} color="primary" autoFocus>
                OK
            </Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
}